var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99996 3.27531C4.64134 3.27531 3.53996 4.37669 3.53996 5.73531C3.53996 7.09393 4.64134 8.19531 5.99996 8.19531C7.35858 8.19531 8.45996 7.09393 8.45996 5.73531C8.45996 4.37669 7.35858 3.27531 5.99996 3.27531ZM2.45996 5.73531C2.45996 3.78022 4.04487 2.19531 5.99996 2.19531C7.95505 2.19531 9.53996 3.78022 9.53996 5.73531C9.53996 7.6904 7.95505 9.27531 5.99996 9.27531C4.04487 9.27531 2.45996 7.6904 2.45996 5.73531Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99996 9.27531C3.53677 9.27531 1.53996 11.2721 1.53996 13.7353C1.53996 14.0335 1.29819 14.2753 0.999961 14.2753C0.701727 14.2753 0.459961 14.0335 0.459961 13.7353C0.459961 10.6757 2.9403 8.19531 5.99996 8.19531C9.05962 8.19531 11.54 10.6757 11.54 13.7353C11.54 14.0335 11.2982 14.2753 11 14.2753C10.7017 14.2753 10.46 14.0335 10.46 13.7353C10.46 11.2721 8.46315 9.27531 5.99996 9.27531Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45996 2.73531C9.45996 2.43708 9.70173 2.19531 9.99996 2.19531C11.955 2.19531 13.54 3.78022 13.54 5.73531C13.54 7.6904 11.955 9.27531 9.99996 9.27531C9.70173 9.27531 9.45996 9.03355 9.45996 8.73531C9.45996 8.43708 9.70173 8.19531 9.99996 8.19531C11.3586 8.19531 12.46 7.09393 12.46 5.73531C12.46 4.37669 11.3586 3.27531 9.99996 3.27531C9.70173 3.27531 9.45996 3.03355 9.45996 2.73531Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45996 8.73531C9.45996 8.43708 9.70173 8.19531 9.99996 8.19531C13.0596 8.19531 15.54 10.6757 15.54 13.7353C15.54 14.0335 15.2982 14.2753 15 14.2753C14.7017 14.2753 14.46 14.0335 14.46 13.7353C14.46 11.2721 12.4632 9.27531 9.99996 9.27531C9.70173 9.27531 9.45996 9.03355 9.45996 8.73531Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialProfiles);
export default __webpack_public_path__ + "static/media/social-profiles.4c7972d4047daed6dc7d1cbcfc377b8f.svg";
export { ForwardRef as ReactComponent };